var _circle, _line, _circle2, _line2, _circle3, _line3, _circle4, _line4, _circle5, _line5, _circle6, _line6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeTrieLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    viewBox: "0 0 680 240",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 340,
    cy: 54,
    r: 18,
    fill: "#EF9F27",
    stroke: "#BA7517",
    strokeWidth: 0.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 327,
    y1: 68,
    x2: 260,
    y2: 112,
    stroke: "#EF9F27",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 252,
    cy: 122,
    r: 14,
    fill: "#FAC775",
    stroke: "#EF9F27",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 353,
    y1: 68,
    x2: 418,
    y2: 112,
    stroke: "#EF9F27",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 426,
    cy: 122,
    r: 14,
    fill: "#FAC775",
    stroke: "#EF9F27",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 242,
    y1: 134,
    x2: 210,
    y2: 156,
    stroke: "#FAC775",
    strokeWidth: 1.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 206,
    cy: 164,
    r: 10,
    fill: "#FAEEDA",
    stroke: "#FAC775",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 262,
    y1: 134,
    x2: 285,
    y2: 156,
    stroke: "#FAC775",
    strokeWidth: 1.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 289,
    cy: 164,
    r: 10,
    fill: "#FAEEDA",
    stroke: "#FAC775",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 416,
    y1: 134,
    x2: 390,
    y2: 156,
    stroke: "#FAC775",
    strokeWidth: 1.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 386,
    cy: 164,
    r: 10,
    fill: "#FAEEDA",
    stroke: "#FAC775",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 436,
    y1: 134,
    x2: 462,
    y2: 156,
    stroke: "#FAC775",
    strokeWidth: 1.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 466,
    cy: 164,
    r: 10,
    fill: "#FAEEDA",
    stroke: "#FAC775",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeTrieLogo);
export default __webpack_public_path__ + "static/media/orange_trie_logo.b73e8a0091bb5ef4f1e94e0b893fee94.svg";
export { ForwardRef as ReactComponent };